import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";

const id = "output2";
const idNext = "output3";
const idPrev = "output1";

const next = `
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - parameter: weapon
        choices:
          - choice: sword
          - choice: dagger
          - choice: axe
          - choice: mace
          - choice: spear
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
      - output parameter: outcome
        default value: good
    logic:
      - assignment: Edmund is an awesome fighter
        expression: "'hero' IS 'Edmund' => 'outcome'='awesome'"
`;

const prev = `
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - parameter: weapon
        choices:
          - choice: sword
          - choice: dagger
          - choice: axe
          - choice: mace
          - choice: spear
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
`;

function ManualOutput2({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_logic") && !document.getElementById("logic_assignment") && (
        <div className={`${styles["container"]} ${styles["container-out2a"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-out2a" className={`${styles["container__text"]}`}>
            <p>To show/hide logic click on the header.</p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-out2a"
            end="header_logic"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      {document.getElementById("logic_alias") && (
        <div className={`${styles["container"]} ${styles["container-out2b"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-out2b"
            className={`${styles["container__text"]} ${styles["container__text"]}`}>
            <p>Click here to add an assignment</p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-out2b"
            end="logic_assignment"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-out2"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>Now, let's assign a conditional value to our output parameter!</p>
            <p>
              Open the <b>FUNCTION LOGIC</b> tab at the bottom of the screen. Under the <b>Assignments</b> section, click <b>ADD ASSIGNMENT</b> and name it <b>Edmund is an awesome fighter</b>.
            </p>
            <p>Then, enter this expression: <b>'hero' IS 'Edmund' =&gt; 'outcome'='awesome'</b>.</p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateOutput2 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resCondition, msg: msgCondition } = tutorialUtils.validateCondition(
      root,
      "root→[function]→simple→[logic]→Edmund is an awesome fighter",
      "'hero' IS 'Edmund' => 'outcome'='awesome'",
    );

    if (!resCondition) {
      setMessage(msgCondition);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualOutput2;
